import React from "react"
import { useMediaQuery } from "react-responsive"
import { Career } from "src/openapi"

import { Box, Typography } from "src/UILibrary"

type Prop = {
  item: Career
}

export const CareerItem = ({ item }: Prop) => {
  const isPC = useMediaQuery({ query: "(min-width: 640px)" })

  return (
    <Box width="100%" sx={{ display: isPC ? "flex" : "block", mb: "20px" }}>
      <Box sx={{ width: isPC ? "20%" : "100%", my: "auto" }}>
        <Typography.SubHeadNormal>{`${item.year}年${item.month}月`}</Typography.SubHeadNormal>
      </Box>
      <Typography.InputFieldTitle lineHeight="24px" sx={{ width: isPC ? "80%" : "100%" }}>
        {item.career}
      </Typography.InputFieldTitle>
    </Box>
  )
}
